export default __webpack_public_path__ + "static/media/banner.6436125f.jpg";